import React, { FC } from 'react'
import { useDispatch } from 'react-redux'
import { useReportViewEvent, useResponsive } from '../../hooks'
import { BuyerLeadsValuePropositionIcon } from '../../components/icons/StepIcons/BuyerLeadsValuePropositionIcon'
import { reportTrackingEvent } from '../../tracking/thunks'
import { Intent } from '../../@types/intent'
import { updateConsultationAccepted } from '../../store/lead/leadSlice'
import Consultation from '../../components/Consultation/Consultation'
import '../../components/Consultation/Consultation.scss'

interface ConsultationStepProps {
  goToNextStep: () => unknown
  goToPreviousStep: () => unknown
  displayBack: boolean
}

export const ConsultationStep: FC<ConsultationStepProps> = (props) => {
  useReportViewEvent({ pageTitle: 'consultation' })
  const { isMobile } = useResponsive()
  const dispatch = useDispatch()

  const goToNextStep = (isConsultationAccepted: boolean) => {
    dispatch(updateConsultationAccepted(isConsultationAccepted))
    dispatch(
      reportTrackingEvent({
        label: `${isConsultationAccepted ? `consultation_submit` : `consultation_skip`}`,
        action: 'realtor-leadengine',
        category: 'residential',
        pageTitle: 'consultation',
        inputValue: Intent.INDEPENDENT_SALE,
        eventName: 'lead_input',
        customDimensions: {
          ga_cd_lead_engine_input_value: Intent.INDEPENDENT_SALE,
        },
      })
    )
    props.goToNextStep()
  }
  const headline = (
    <div>Ich berate dich zu deinem Verkaufsvorhaben –{!isMobile && <br />} individuell und ohne Verpflichtungen.</div>
  )

  return (
    <Consultation
      goToNextStep={(isConsultationAccepted) => goToNextStep(isConsultationAccepted ?? false)}
      displayBack={true}
      headline={headline}
      textString={'Kostenlos beraten lassen'}
      goToPreviousStep={props.goToPreviousStep}
      icon={<BuyerLeadsValuePropositionIcon />}
      className={'consultation-step'}
    />
  )
}

export default ConsultationStep
